export enum ActivationStep {
    BISS='BISS', OTP='OTP', PIN='PIN', DOCUMENTS='DOCUMENTS'
}

export enum BissCheckStep {
    ONGOING='ONGOING', NOT_FOUND='NOT_FOUND', FOUND='FOUND', FOUND_OLD_VERSION='FOUND_OLD_VERSION'
}

export enum ActivationStatusStep {
    SUCCESSFULLY_CHANGE_PIN_PUK = "SUCCESSFULLY_CHANGE_PIN_PUK",
    CERTIFICATE_ISSUED = "CERTIFICATE_ISSUED",
    ORDER_CONSUMED = "ORDER_CONSUMED",
    INVOICE_CREATED = "INVOICE_CREATED",
    CERTIFICATE_WRITTEN = "CERTIFICATE_WRITTEN",
    REJECT_SIGN_DOCUMENTS = "REJECT_SIGN_DOCUMENTS",
    SUCCESSFULLY_SIGN_DOCUMENTS = "SUCCESSFULLY_SIGN_DOCUMENTS"                     

}

export class ActivationData { 
    documentId:string
    documentType: string
    serviceRequestId:string
    status:string
    usageStatusId:string
    agentId:string
    agentEmail:string
    clientURL:string    
    cmrId:string
    orderNumber:string
    deliveryStatus:string
}

export class SmartCardData {
    csp: string
    cardSerialNumber: string
    originalPin: string
    originalPuk: string
}

export class SignedContent {
        public content: string
        public signedContent: string
        public signedContentCert: string
        public digestTime: number
        public originalContent: string

        public filename: string
        public type: string
    
}
export class BissSignedContent {
    constructor(
        public content: string,
        public signature: string,
        public certificate: string,

        public originalContent: string,
        public digestTime: number,
        public filename: string = '',
        public type: string = '') {
    }
}
export interface IBissLoginResponse {
    reasonCode: number;
    reasonText: string;
    signatureType: string;  // "signature"
    signatures: string[];
    status: string;

}

export class BissSerialResponse {
    "status": string
    "reasonCode": string
    "reasonText": string
    "cardSerialNumber": string
    "vendor":string
    "code": string
}

export class BTrustIssuedCertificate {
    "certificate": string
    "valid" : any
}

export interface DownloadLinkData {
    os: OperatingSystem;
    bissMinVersion: number;
    bissDownloadLink: string;
    sacDownloadLink: string;
}

export enum OperatingSystem {
    WINDOWS = "WINDOWS",
    LINUX = "LINUX",
    MAC = "MAC",
    Windows = "WINDOWS",
    Linux = "LINUX",
    Mac = "MAC"
}
